export const shouldIgnoreRowNavigation = (target: EventTarget | null) => {
  return (
    target instanceof Element &&
    target.closest(
      'a,button,input,select,textarea,label,[role="button"],[role="link"]',
    ) !== null
  );
};
